export const articleMapper = {
  toAPI: articleObject => {
    const currentURL = window.location.href;

    return {
      id: articleObject.id,
      headline: articleObject.headline,
      url: currentURL
    };
  },
  toDomain: (articleObject, commentsCount, createdAt) => ({
    ...articleObject,
    commentsCount,
    createdAt
  })
};
